import Vue from 'vue'
import Vuex from 'Vuex'
import VuexPersistence from 'vuex-persist'
import Crypto from 'crypto-js'
import Cookie from 'js-cookie'
import { getField, updateField } from 'vuex-map-fields'
// import { v4 as uuidv4 } from 'uuid'
import moment from 'moment';

const cookieName = 'cookieName'

const storageKey = 'key'

Vue.use(Vuex)

// Get the encryption token from cookie or generate a new one.
const encryptionToken = process.env.TOKENENCRYPTION_KEY

// Store the encryption token in a secure cookie.
Cookie.set(cookieName, encryptionToken, { secure: true, expires: 86400 })

const vuexLocal = new VuexPersistence({
  storage: {
    getItem: () => {
      const stored = window.localStorage.getItem(storageKey)
      if (stored) {
        try {
          // Decrypt the store retrieved from local storage
          // using our encryption token stored in cookies.
          const bytes = Crypto.AES.decrypt(stored, encryptionToken)

          return JSON.parse(bytes.toString(Crypto.enc.Utf8))
        } catch (e) {
          // The store will be reset if decryption fails.
          // window.localStorage.removeItem(storageKey)
        }
      }
      return null
    },
    setItem: (key, value) => {
      // Encrypt the store using our encryption token stored in cookies.
      const stored = Crypto.AES.encrypt(value, encryptionToken).toString()

      // Save the encrypted store in local storage.
      return window.localStorage.setItem(storageKey, stored)
    }
    // removeItem: () => window.localStorage.removeItem(storageKey)
  }
})

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    selectedMultiroom: null,
    discount: 0,
    GatewayFee: 0,
    roomNo: '',
    promoCode: '',
    Enhancement: false,
    multi_room_book: false,
    spinner: false,
    addedhenancement: [],
    bookings: [],
    checkinDate: moment().format('YYYY-MM-DD'),
    checkoutDate: '',
    checkindatemultiroom: '',
    checkoutdatemultiroom: '',
    period: '',
    room: '',
    multiRoomResulttest: null,
    board: '',
    proofRes: '',
    residency: '',
    enhancementprice: 0,
    serviceCharge: 0,
    totalVat: 0,
    cateringLevy: 0,
    total: 0,
    totalM: 0,
    room_price: 0,
    board_price: 0,
    totalAdult: 0,
    totalChildren: 0,
    totalBabies: 0,
    adults: '',
    children: '',
    rcheckinDate: '',
    rcheckoutDate: '',
    babies: '',
    childAges: null,
    referenceNumber: '',
    selectedrooms: '',
    subtotal: 0,
    occupancy: '',
    selectedenhancements: '',
    currency: '',
    totalRoomPrice: '',
    totalEnhancementPrice: '',
    subTotal: '',
    totalDiscount: '',
    totalServiceCharge: '',
    totalHotelTax: '',
    totalVAT: '',
    totalGatewayFee: '',
    totalAmountPayable: '',
    pid: '',
    name: '',
    vat: '',
    extra_charges: '',
    gateway_fee: '',
    iframeLink: '',
    chargeType: '',
    // occupancy
    roomOccupancy: [
      {
        adults: '',
        children: '',
        mealplan: ''
      }
    ],
    bookingDetails: {},
    datesEditResponse: {},
    bookingCancelled: false,
    drbsource: '',
    errors: [],
    bookingSummaryOn: false,
    loyalty_pay_info: {},
    loyaltyIsEnabled: false,
    gtmContainerId: null
  },
  getters: {
    getField,
    bookingDetails: state => state.bookingDetails,
    datesEditResponse: state => state.datesEditResponse,
    getLoyaltyPayAmount: state => state.loyalty_pay_info.redeem_amount,
    getIsLoyaltyEnabled: state => state.loyaltyIsEnabled,
    checkinDate: state => state.checkinDate,
    checkoutDate: state => state.checkoutDate,
    errors: state => state.errors,
    bookingSummaryOn: state => state.bookingSummaryOn
  },
  mutations: {
    updateField,
    updateIframe (state, payload) {
      state.iframeLink = payload.iframe
      state.chargeType = payload.chargeType
    },
    updatePaymentInfo (state, payload) {
      state.referenceNumber = payload.referenceNumber
      state.selectedrooms = payload.rooms
      state.occupancy = payload.occupancy
      state.selectedenhancements = payload.enhancements
      state.currency = payload.currency
      state.totalRoomPrice = payload.totalRoomPrice
      state.totalEnhancementPrice = payload.totalEnhancementPrice
      state.subTotal = payload.subTotal
      state.totalDiscount = payload.totalDiscount
      state.totalServiceCharge = payload.totalServiceCharge
      state.totalHotelTax = payload.totalHotelTax
      state.totalVAT = payload.totalVAT
      state.totalGatewayFee = payload.totalGatewayFee
      state.totalAmountPayable = payload.totalAmountPayable
      state.pid = payload.pid
      state.name = payload.name
      state.vat = payload.vat
      state.extra_charges = payload.extra_charges
      state.iframeLink = payload.iframeLink
      state.chargeType = payload.chargeType
    },
    updateRoomNo (state, payload) {
      state.roomNo = payload.roomNo
      state.promoCode = payload.promoCode
      state.proofRes = payload.proofRes
      state.residency = payload.residency
    },
    updateOccupancy (state, payload) {
      state.totalAdult = payload.totalAdult
      state.totalChildren = payload.totalChildren
      state.totalBabies = payload.totalBabies
    },
    confirmMultiBook (state, payload) {
      state.multi_room_book = payload
    },
    gotoMultiRoomBookDetail (state, payload) {
      state.selectedMultiroom = payload.selectedmultiroom
      state.multiRoomResulttest = payload.result
      state.proofRes = payload.res
      state.checkindatemultiroom = payload.checkindate
      state.checkoutdatemultiroom = payload.checkoutdate
      state.checkinDate = payload.checkindate
      state.checkoutDate = payload.checkoutdate
    },
    updatedTotal (state, payload) {
      state.total = payload
    },
    setSelectedEnhancement (state, payload) {
      state.addedhenancement = payload.data
      state.Enhancement = payload.Enhancement
    },
    getRoomBookingData (state, payload) {
      state.bookings = payload.bookingData
    },
    getBookingData (state, payload) {
      state.bookings = payload.bookingData
      state.period = payload.stay_period
      state.babies = payload.babies
      state.childAges = payload.childAges
    },
    gotoBookDetail (state, payload) {
      state.room = payload.room
      state.board = payload.board
      state.proofRes = payload.res
      state.residency = payload.resident
      state.adults = payload.adults
      state.children = payload.children
      state.babies = payload.babies
      // state.checkinDate = payload.checkin_date
      // state.checkoutDate = payload.checkout_date
    },

    updateCheckinDate (state, value) {
      state.checkinDate = value
    },

    updateCheckoutDate (state, value) {
      state.checkoutDate = value
    },

    updateDates (state, payload) {
      state.checkinDate = payload.checkin_date
      state.checkoutDate = payload.checkout_date
    },
    updateRoomCheckDates (state, payload) {
      state.rcheckinDate = payload.checkindate
      state.rcheckoutDate = payload.checkoutdate
    },
    updateBoardPrice (state, payload) {
      state.board_price = payload
    },
    updatePrices (state, payload) {
      state.subtotal = payload.subtotal
      state.serviceCharge = payload.servicecharges
      state.totalVat = payload.totalvat
      state.cateringLevy = payload.hoteltax
      state.total = payload.total
      state.discount = payload.discount
      state.GatewayFee = payload.GatewayFee
    },
    updateBookingDetails (state, details) {
      state.bookingDetails = details
    },
    updateEditDatesResponse (state, details) {
      state.datesEditResponse = details
    },
    setError(state, error) {
      state.errors.push(error)
    },
    clearErrors(state) {
      state.errors = []
    },

    updateBookingSummaryOn(state, value) {
      state.bookingSummaryOn = value
    },
    updateLoyaltyDetails (state, details) {
      state.loyalty_pay_info = details
    },
    deductRedeemedAmountFromTotals (state, details) {
      state.total.res = state.total.res - details.res
      state.total.nonres = state.total.nonres - details.nonres
    },
    CLEAR_LOYALTY_DETAILS (state) {
      state.loyalty_pay_info = {}
    },
    updateLoyaltyIsEnabled (state, loyaltyIsEnabled) {
      state.loyaltyIsEnabled = loyaltyIsEnabled
    },
    updateGtmContainerId (state, gtmContainerId) {
      // console.log('gtm container id is '+gtmContainerId);
      state.gtmContainerId = gtmContainerId
    }
  },
  actions: {
    updateOccupancy (state, payload) {
      state.commit('updateOccupancy', payload)
    },
    getMultiRoom (state, payload) {
      state.commit('getMultiRoom', payload)
    },
    updatedTotal (state, payload) {
      state.commit('updatedTotal', payload)
    },
    setSelectedEnhancement (state, payload) {
      state.commit('setSelectedEnhancement', payload)
    },
    getBookingData (state, payload) {
      state.commit('getBookingData', payload)
    },
    gotoBookDetail (state, payload) {
      state.commit('gotoBookDetail', payload)
    },
    gotoMultiRoomBookDetail (state, payload) {
      state.commit('gotoMultiRoomBookDetail', payload)
    },
    updatePrices (state, payload) {
      state.commit('updatePrices', payload)
    },
    updateBoardPrice (state, payload) {
      state.commit('updateBoardPrice', payload)
    },
    confirmMultiBook (state, payload) {
      state.commit('confirmMultiBook', payload)
    },
    updateCheckinDate ({ commit }, value) {
      commit('updateCheckinDate', value)
    },
    updateDates ({commit}, payload) {
      commit('updateDates', payload)
    },
    triggerErrors({ commit }, error) {
      commit('setError', error)
    },
    clearAllErrors({ commit }) {
      commit('clearErrors')
    },
    updateBookingSummaryOn({ commit }, value) {
      commit('updateBookingSummaryOn', value)
    }

  }
})



// WEBPACK FOOTER //
// ./src/store.js